<template>
  <div ref="FlashMessage" class="FlashMessage">
    <div v-for="message in msg.messages" :key="message.index" v-html="message.text"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msg: { messages: [], msgOpen: null, msgClose: null }
    };
  },
  methods: {
    show(message, duration) {
      duration = duration || 3000;
      let msg = this.msg;
      msg.messages.push({ index: msg.messages.length, text: message });
      let _flashMessage = this.$refs.FlashMessage;
      if (msg.msgOpen) {
        window.clearTimeout(msg.msgOpen);
      }
      if (msg.msgClose) {
        window.clearTimeout(msg.msgClose);
      }
      _flashMessage.classList.add("Open");
      msg.msgOpen = window.setTimeout(function() {
        _flashMessage.classList.remove("Open");
        _flashMessage.classList.add("Close");
        msg.msgClose = window.setTimeout(function() {
          _flashMessage.classList.remove("Close");
          msg.messages = [];
        }, 300);
      }, duration);
    }
  }
};
</script>
<style>
.FlashMessage {
  position: fixed;
  opacity: 0;
  z-index: 999999999;
  border: solid 1px;
  padding: 20px 10px;
  width: 300px;
  left: -300px;
  text-align: center;
  background-color: rgba(250, 250, 255, 0.97);
  color: black;
  border-radius: 5px;
  border: solid 2px black;
  bottom: 150px;
  font-size: 110%;
  font-weight: bold;
  transition: all 300ms;
  box-shadow: 0px 0px 30px gray;
}

.FlashMessage.Open {
  opacity: 1;
  left: calc(50% - 150px);
}
.FlashMessage.Close {
  opacity: 0;
  left: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/ekkControls/FlashMessage.vue